import { ReactNode } from 'react';

export const PlateItem = ({ children }: { children: ReactNode }) => {
  return children;
};
